/**
 * STT (Speech-to-Text) API
 * Endpoint is controlled via STT2_API_ENDPOINT in .env
 * Falls back to AIPNT_API_URL + /api/ai/transcribe if STT2_API_ENDPOINT is not set
 */
const STT_ENDPOINT = process.env.STT2_API_ENDPOINT ||
    (process.env.AIPNT_API_URL ? `${process.env.AIPNT_API_URL}/api/ai/transcribe` : null);

const postJson = async (url, body) => {
    const token = sessionStorage.getItem('aipnt_device_session');
    const headers = {'Content-Type': 'application/json'};
    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new Error(`STT service returned HTTP ${response.status}`);
    }

    return response.json();
};

const requestTranscription = async payload => {
    if (!STT_ENDPOINT) {
        throw new Error('STT endpoint is not configured. Set STT2_API_ENDPOINT or AIPNT_API_URL in your .env file.');
    }
    return postJson(STT_ENDPOINT, payload);
};

export {
    requestTranscription
};
